import * as React from "react";

import { useBillingContext } from "../../contexts/BillingContext";
import { useFeatureFlags } from "../../hooks/useFeatureFlags";
import { planHasFeature, type PlanFeature } from "../../types/billing";
import PlanLockedScreen from "./PlanLockedScreen";

/**
 * Shows the holding screen instead of a route the user's plan doesn't include.
 * Admins and paid plans with the feature see the route. While billing loads, the route renders
 * (its API calls are gated on the backend too).
 */
export default function PlanRouteGate({
  feature,
  children,
}: {
  feature: PlanFeature | null;
  children: React.ReactNode;
}) {
  const { isLoading, status } = useBillingContext();
  const { isAdmin } = useFeatureFlags();
  if (!feature || isLoading || isAdmin || planHasFeature(status, feature)) {
    return <>{children}</>;
  }
  return <PlanLockedScreen feature={feature} />;
}
